import React, { Component } from 'react'
import InstanciaBasic from './InstanciaBasic.js'
import * as Constants from '../constants.js'

class InstanciaNumber extends InstanciaBasic {
	constructor(props) {
    super(props);
		this.castValue = this.castValue.bind(this);

  }

	castValue(value) {
		if (value) {
			if (isNaN(value))
				return 0
			else
				return Number(value)
		} else
			return ''
	}

	render() {
      return (
        <React.Fragment>
					<input
						disabled={this.props.disabled}
						type="number"
						className="form-control"
						value={this.props.atributo[this.valueKey]}
						onChange={this.handleInputChange}
					/>
        </React.Fragment>
      )
  }
}

export default InstanciaNumber;
